export const CONTAINER_CLASS =
    "max-w-[92%] sm:max-w-[95%] mx-auto grid grid-cols-1 md:grid-cols-2 mb-44 mt-10";

export const DETAILS_CONTAINER = "flex flex-col justify-center md:px-5";

export const SIGNATURE_CONATINER = "pt-4 flex justify-end";

export const SIGNATURE_IMG = "h-[50px] w-[193px]";

export const BREAK_POINT_WIDTH = 540;